import { of } from "rxjs";
import { IdErrorCore } from "../../../constants/IdErrorCore";
import { actionErrorThrowError } from "../actionError";
export var pathHandleTextError = function (action, state$, deps) {
    return of(actionErrorThrowError(IdErrorCore.TextErrors, action.statusCode));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/errors/path/pathHandleTextError.ts
// module id = 1851
// module chunks = 3